import {segment} from './helpers'

export const viewedRentToKeepShoppingPage = () => segment('Viewed RTK Shopping Page')

export const addedRentToKeepProducts = (items) => segment('Added RTK Products', {items})

export const clickedRentToKeepCheckoutSubmit = () => segment('Clicked RTK Checkout Submit')
